export default __webpack_public_path__ + "static/after-1-8b4463dc4ab63c72502c269f7a33a2ea.jpg";